import client from "./Client";

const addPayment = (
  adminId,
  school_id,
  amount,
  charge_rate,
  status,
  discount
) =>
  client.post(
    "/school/payment/add",
    {
      id: adminId,
      school_id,
      amount,
      charge_rate,
      status,
      discount,
    }
  );

const getPayments = (page, rows, search) => {
  const params = {};
  if (page) {
    params.page = page;
  }
  if (rows) {
    params.rows = rows;
  }
  if (search) {
    params.search = search;
  }
  return client.get(`/school/payments`, {
    params,
  });
};

const updatePayment = (
  payment_id,
  admin_id,
  school_id,
  amount,
  charge_rate,
  status,
  discount
) =>
  client.post(
    "/school/update",
    {
      admin_id,
      payment_id,
      school_id,
      amount,
      charge_rate,
      status,
      discount,
    }
  );

const getSinglePayment = (schoolId, paymentId) => {
  return client.get(`/school/${schoolId}/payment/${paymentId}`);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  addPayment,
  getPayments,
  updatePayment,
  getSinglePayment,
};
